<template>
  <div class="auth-layout">
    <div class="auth-layout__container">
      <div class="auth-layout__wrapper">
        <div class="auth-layout__lang">
          <LangSelect down/>
        </div>

        <h1 class="auth-layout__title" v-html="$t('auth-layout.title')" />
        <div class="auth-layout__content">
          <slot />
        </div>
        <MainSponsors />
      </div>
      <img
        src="@/assets/icons/sponsor-ank.png"
        :srcset="srcsetAnk"
        class="auth-layout__sponsor-ank"
        alt="sponsor ank"
      />
    </div>

    <lottie-player
      class="auth-layout__animation"
      src="/auth-animation.json"
      background="transparent"
      speed="1"
      autoplay
      loop
      style="position: absolute; width: auto; min-width: 25%; max-width: 830px; height: 100vh; right: 0; top: 0"
    ></lottie-player>
  </div>
</template>

<script>
import MainSponsors from '@/components/MainSponsors'
import LangSelect from '@/components/navbar/LangSelect'

export default {
  name: 'authLayout',
  components: {LangSelect, MainSponsors },
  data: () => ({
    srcsetAnk: `${require('@/assets/icons/sponsor-ank@2x.png')} 2x`,
  }),
  created() {
    if (this.isPC()) {
      let tag = document.head.querySelector(`script.lottie`)
      if (!tag) {
        tag = document.createElement('script')
        tag.className = 'lottie'
        tag.setAttribute('src', 'https://unpkg.com/@lottiefiles/lottie-player@latest/dist/lottie-player.js')
        tag.setAttribute('type', 'text/javascript')
        document.head.appendChild(tag)
      }
    }
  },
  methods: {
    isPC() {
      return window.matchMedia('(min-width: 768px)').matches
    },
  },
}
</script>

<style lang="scss">
#content.auth-layout {
  min-height: 100vh;
  width: 100%;
  max-width: none;
  margin: 0;
  border-radius: 0;
  background: $white;

  @include mobile {
    background: none;
    .auth-layout__animation {
      display: none !important;
    }
  }
}

.auth-layout {
  display: flex;
  align-items: center;

  &__lang {
    margin-bottom: 28px;

    @include mobile() {
      position: absolute;
      top: 0;
      left: 0;
    }
  }

  &__container {
    max-width: 100%;
    width: 1135px;
    margin: 0 auto;
    position: relative;

    button {
      border-radius: 10px;
      height: 44px;
    }
  }

  &__wrapper {
    position: relative;
    z-index: 2;
    width: 440px;
    padding: 60px 60px 40px;
    min-height: 530px;

    @include PC {
      background: $white;
      box-shadow: 1px -1px 102px rgba(180, 187, 198, 0.3);
      border-radius: 20px;
    }

    @include mobile {
      margin: 0 auto;
      width: auto;
      max-width: 295px;
      padding: 146px 0 0;
    }

    .main-sponsors {
      margin-top: 25px;

      @include mobile {
        margin-top: 56px;
      }
    }
  }

  &__animation {
    @include mobile {
      display: none;
    }
  }

  &__logo {
    margin-bottom: 50px;
  }

  &__title {
    font-weight: 700;
    font-size: 24px;
    line-height: 116%;
    margin-bottom: 40px;

    @include PC {
      font-weight: 600;
      letter-spacing: -0.02em;
      color: #474747;
    }
  }

  &__sponsor-ank {
    position: absolute;
    right: 0;
    bottom: 0;

    @include mobile {
      max-width: calc(100% - 39px);
      width: 295px;
      top: 57px;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  form {
    input {
      margin-bottom: 20px;

      + .terms-block {
        margin-top: -5px;
      }
    }
  }
}
</style>
